export default "__VITE_ASSET__62t2mRw7__"